<template>
  <vx-card class="mt-4 px-2">
    <div class="mb-4" v-show="addressIsPrimary">
      <h5>Primary</h5>
    </div>
    <div class="grid grid-cols-3 gap-4 content-inputs">
      <div>
        <label class="mb-2 block">Address Type</label>
        <v-select
          class="w-full"
          :clearable="false"
          placeholder=" "
          name="AddressType"
          v-validate="'required'"
          v-model="address_type_local"
          :options="addressTypeOptions"
        />
        <validation-message v-show="vErrors.has('AddressType')">
          {{ vErrors.first("AddressType") }}
        </validation-message>
      </div>

      <div>
        <label class="mb-2 block">Address Line 1</label>
        <vs-input
          class="w-full"
          name="AddressLine1"
          v-validate="'required'"
          v-model="data_local.AddressLine1"
        />
        <validation-message v-show="vErrors.has('AddressLine1')">
          {{ vErrors.first("AddressLine1") }}
        </validation-message>
      </div>

      <div>
        <label class="mb-2 block">Address Line 2 (Optional)</label>
        <vs-input class="w-full" v-model="data_local.AddressLine2" />
      </div>
      <div>
        <label class="mb-2 block">Address Line 3 (Optional)</label>
        <vs-input class="w-full" v-model="data_local.AddressLine3" />
      </div>

      <div>
        <label class="mb-2 block">City</label>
        <vs-input
          class="w-full"
          name="City"
          v-validate="'required'"
          v-model="data_local.City"
        />
        <validation-message v-show="vErrors.has('City')">
          {{ vErrors.first("City") }}
        </validation-message>
      </div>
      <div>
        <label class="mb-2 block">Province (Optional)</label>
        <vs-input class="w-full" v-model="data_local.Province" />
      </div>
      <div>
        <label class="mb-2 block">Region (Optional)</label>
        <vs-input class="w-full" v-model="data_local.Region" />
      </div>

      <div>
        <label class="mb-2 block">Post Code</label>
        <vs-input
          class="w-full"
          name="PostalCode"
          v-validate="'required'"
          v-model="data_local.PostCode"
        />
        <validation-message v-show="vErrors.has('PostalCode')">
          {{ vErrors.first("PostalCode") }}
        </validation-message>
      </div>
      <div>
        <label class="mb-2 block">Country</label>
        <v-select
          class="w-full"
          name="Country"
          v-validate="'required'"
          placeholder=""
          v-model="data_local.Country"
          :options="countryOptions"
        />
        <validation-message v-show="vErrors.has('Country')">
          {{ vErrors.first("Country") }}
        </validation-message>
      </div>
    </div>

    <slot name="contact-numbers"></slot>

    <div class="vs-row">
      <div v-if="showButtons" class="vx-col w-full">
        <div class="mt-3">
          <div class="inline-block">
            <vs-button @click="remove()" color="dark" type="flat">
              Remove
            </vs-button>
          </div>
          <span v-if="!isPrimary">|</span>
          <div v-if="!isPrimary" class="inline-block">
            <vs-button @click="makePrimary()" color="dark" type="flat">
              Set as Primary
            </vs-button>
          </div>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import ValidationMessage from '../validation/ValidationMessage';
import vSelect from 'vue-select';
import CountryList from 'countries-list';

export default {
  components: {
    ValidationMessage,
    vSelect
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    isPrimary: {
      required: false,
      default: false
    },
    showButtons: {
      required: false,
      default: false
    },
    validationIndex: {
      required: false,
      default: null
    }
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.value)),
      rawAddressTypeOptions: []
    };
  },
  computed: {
    countryOptions() {
      const countryList = [];

      for (const [key, country] of Object.entries(CountryList.countries)) {
        countryList.push(country.name);
      }

      return countryList;
    },
    address_type_local: {
      get() {
        const addressType = this.rawAddressTypeOptions.find(
          ({ id }) => id === parseInt(this.data_local.AddressType_FK)
        );

        if (!addressType) {
          return addressType;
        }

        return { label: addressType.Type, value: addressType.id };
      },
      set(val) {
        this.data_local.AddressType_FK = val.value;
      }
    },
    phone_numbers_local: {
      get() {
        if (!this.data_local.phone_numbers) {
          return [];
        }

        return this.data_local.phone_numbers.map(
          ({
            CompanyPhoneNumber_PK,
            PhoneType_FK,
            CountryCode,
            PhoneNumber,
            PhoneExtension,
            IsPrimaryNumber
          }) => {
            return {
              id: CompanyPhoneNumber_PK,
              value: PhoneNumber,
              dropdownValue: PhoneType_FK,
              secondaryValue: CountryCode,
              additionalInputValue: PhoneExtension,
              primary: IsPrimaryNumber
            };
          }
        );
      }
    },
    addressIsPrimary() {
      return Boolean(parseInt(this.data_local.IsPrimaryAddress));
    },
    addressTypeOptions() {
      return this.rawAddressTypeOptions.map(({ id, Type }) => {
        return { label: Type, value: id };
      });
    },
    validateForm() {
      return !this.vErrors.any();
    }
  },
  watch: {
    data_local: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true
      //immediate: true,
    },
    value: {
      handler(newValue) {
        this.data_local = newValue;
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.getRelatedData();
  },
  methods: {
    validationName(name) {
      if (this.validationIndex >= 0) {
        return `${name} ${this.validationIndex + 1}`;
      }

      return name;
    },
    remove() {
      this.$emit('remove');
    },
    makePrimary() {
      this.$emit('makePrimary');
    },
    async getAddressTypes() {
      try {
        const { data } = await this.$api.userAddress.getOptions();
        this.rawAddressTypeOptions = data.data;
      } catch (e) {
        console.log(e);
        this.$vs.notify({
          title: 'Error occurred',
          text: 'Not able to retrieve email type options. Please try again.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        });
      }
    },
    async getRelatedData() {
      await this.getAddressTypes();
    }
  }
};
</script>
